/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { FitinsurAPI, MessageCenter } from 'utils';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { Row, Col } from "components/Grid";
import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import ContentCard from 'components/ContentCard';
import TextField from 'components/Form/TextField';
import { RadioButtonGroup } from 'components/Form/Radio';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { Scrollbox, Footer, Title } from './styles';
import DialogComponent from 'components/ModalCancel';
import { LostCancelButton } from 'components/index';
import HasPermission from 'components/HasPermission/index';

export default function ContactSelectionEndorsement(props) {
  const [summary, setSummary] = useState({});
  const [insurers, setInsurers] = useState([]);
  const [operationStatus, setOperationStatus] = useState(null);
  const [time, setTime] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [dialog, setDialog] = useState({ visible: false });
  const [endorsmentType, setEndorsmentType] = useState("");
  const [isBound, setIsBound] = useState(false);

  const loading = useContext(GlobalLoaderContext);
  const history = useHistory();
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const formik = useRef(Formik);  

  function requestBindMessage() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.endorsementOffRiskFormData(props.match.params.idOperation)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code != 200) {
          mc.error(resp.ret_msg_details);
          history.goBack();
          return;
        }
        if (formik.current) {
          formik.current?.setFieldValue('message', resp.ret_value.endorsementOffRiskMessage);
        }
      }).catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setEndorsmentType(data.ret_value.endorsmentType);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleSelect(contact, insurer) {

    const select = { idPersonInsurer: insurer.idPersonInsurer, idContact: contact.idContact, email: contact.email, name: contact.nameContact };

    const alreadySelected = selectedItems.findIndex((item) => item.idPersonInsurer === select.idPersonInsurer);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.idPersonInsurer !== select.idPersonInsurer);
      filteredItems.push(select);
      setSelectedItems(filteredItems);
    } else {
      setSelectedItems([...selectedItems, select]);
    };
  };

  function listContacts() {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.endorsementOffRiskListContact(props.match.params.idOperation).then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        if (data.ret_value.length > 0) {
          setInsurers(data.ret_value);
          loading.stop();
        }
      })
      .catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });

  };

  function getStatusOperation() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestValidatePolicyStampStatus(props.match.params.idOperation).then(response => response.json())
      .then(data => {

        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        setOperationStatus(data.ret_value.statusOperation?.toLowerCase());
        if (data.ret_value.errorMessage && data.ret_value.errorMessage.trim().length) {
          mc.error(data.ret_value.errorMessage)
          clearInterval(time);
          loading.stop();
        }
      }).catch((error) => {
        loading.stop();

        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  }

  const handleContacts = (contacts) => {
    if (!insurers) {
      return;
    }
    const Arr = contacts.map(item => {
      return {
        label: `${item.nameContact}  :  ${item.email}.`,
        value: { email: item.email, idContact: item.idContact, nameContact: item.nameContact }
      }
    })
    return Arr;
  }

  const handleSubmit = (e) => {
    loading.start();

    if (selectedItems.length < insurers.length) {
      mc.error('Please, select at least one contact for insurer');
      return;
    }

    let body = {
      idOperation: props.match.params.idOperation,
      insurers: [...selectedItems],
      contactsFormik: e.insurers,
      message: e.message
    }

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSendPolicyStamp(body.idOperation, body.insurers, body.message)
      .then(response => response.json())
      .then(data => {

        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        const searchStatus = setInterval(getStatusOperation, 2000);
        setTime(searchStatus);
      })
      .catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  }

  async function handleOperationInfo() {
    loading.start()
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.match.params.idOperation)
      .then(response => response.json())
      .then(response => {
        setIsBound(response?.isBound);
        loading.stop();
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
        loading.stop();
      });
  }

  useEffect(() => {
    if (formik) {
      insurers.forEach((insurer, index) => {
        const item = {
          IdPersonInsurer: insurer.idPersonInsurer,
          insurerFirstName: insurer.insurerFirstName,
          nmInsurer: insurer.nmInsurer,
          contact: null
        }
        if (formik.current) {
          formik.current?.setFieldValue(`${insurer.idPersonInsurer}`, item);
        }
      });
    }
    console.log("FOrmik", formik.current.values);
  }, [insurers])

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };

    requestBindMessage();
    handleSummary();
    listContacts();
    handleOperationInfo();
  }, []);

  useEffect(() => {
    if (operationStatus == 'created') {
      clearInterval(time);
      history.push(`/broking/stamps-status-list/${props.match.params.idOperation}`);
      loading.stop();
    } else if (operationStatus == 'processing_error') {
      clearInterval(time);
      loading.stop();
      //mc.error(operationErrorMessage);
    }
  }, [operationStatus]);

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"} subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}>
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />

      <Scrollbox>

        <BrokingSummary data={summary} />

        <ContentCard
          title={endorsmentType === "adjustments" ? "ENDORSEMENT ADJUSTMENTS & CRRECTIONS - CONTACT SELECTION" : "ENDORSEMENT - OFF RISK - CONTACTS SELECTION"}
          icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
        >

          <DialogComponent history={history} show={dialog.visible} setDialog={setDialog} idOperation={props.match?.params?.idOperation} />
          <Formik
            innerRef={formik}
            initialValues={{}}
            onSubmit={handleSubmit}
          //validationSchema={validations}
          >
            {formikProps => (
              <Form>

                <Row>
                  <Col md={12} sm={12}>
                    <Title>TO</Title>
                    {
                      insurers.map((insurer, index) => (
                        <Col key={index} md={12}>
                          <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                            <Title>
                              {insurer.insurerFirstName}
                            </Title>
                          </Row>
                          <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
                            <Col>
                              <Field
                                key={insurer.idPersonInsurer}
                                style={{ marginTop: 10 }}
                                name={`${insurer.idPersonInsurer}`}
                                fieldName={insurer.insurerFirstName}
                                options={handleContacts(insurer.contacts)}
                                onChange={(e) => {
                                  handleSelect(e, insurer, index);
                                  formik.current?.setFieldValue(`${insurer.idPersonInsurer}.contact`, e)
                                }}
                                component={RadioButtonGroup}
                                isRequired
                              />
                            </Col>
                          </Row>
                        </Col>)
                      )
                    }

                    <Field
                      style={{ marginTop: 10 }}
                      label={'Message'}
                      name={'message'}
                      value={formikProps.values.message}
                      onChange={(e) => formikProps?.setFieldValue('message', e)}
                      component={TextField}
                      disabled
                    />
                  </Col>
                </Row>

                <Footer>
                  <ButtonContainer>
                    <Button forth onClick={() => { history.goBack() }}>&lt; Back</Button>
                    <HasPermission permission={!isBound}>
                      <ButtonContent>
                        <LostCancelButton idOperation={props.match?.params?.idOperation} />
                        <HasPermission permission={props.permissions.EXECUTION}>
                          <Button primary type='submit' style={{ marginLeft: "10px" }}>
                            STAMPS REQUEST
                          </Button>
                        </HasPermission>
                      </ButtonContent>
                    </HasPermission>
                  </ButtonContainer>
                </Footer>
              </Form>
            )}
          </Formik>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}